import { Component, forwardRef } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Subject } from 'rxjs';
import { EaRenonciationFormBuilder } from './ea-renonciation-form.builder';

@Component({
  selector: 'ea-renonciation-form',
  templateUrl: './ea-renonciation-form.component.html',
  styleUrls: ['./ea-renonciation-form.component.scss'],
  providers: [
    {
      provide: PrFormAbstract,
      useExisting: forwardRef(() => EaRenonciationFormComponent),
    },
  ],
  standalone: false,
})
export class EaRenonciationFormComponent extends EaRenonciationFormBuilder {
  doneSubject: Subject<void> = new Subject<void>();

  renunciationMethods = [
    { id: 'EMAIL', label: 'E-mail' },
    { id: 'COURRIER', label: 'Courrier' },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private httpApi: HttpApiService,
  ) {
    super(formConstructor);
  }

  get title() {
    return 'Renonciation au contrat';
  }

  get reasonLength(): number {
    return this.form.get('reason')?.value?.length || 0;
  }

  onSubmit() {
    this.prFormService.loading();
    this.httpApi
      .post(
        `/accounts/${this.entity.accountId}/assets-financial/${this.entity.assetId}/renonciation`,
        this.extract(),
      )
      .subscribe({
        next: () => {
          this.prFormService.loaded();
          this.notificationService.success(
            'Votre demande de renonciation a bien été enregistrée',
          );
          this.doneSubject.next();
        },
        error: errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error(
            'La demande de renonciation a échoué',
          );
        },
      });
  }

  onCancel() {
    this.prFormService.close();
  }
}
